import PropTypes from "prop-types";
import React, { useCallback } from "react";
import Select from "react-select";

import OptionsAdapter from "utils/OptionsAdapter";

import "./_style.scss";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    marginTop: "0",
  }),

  control: (provided, state) => ({
    ...provided,
    borderColor: "#d9d9d9",
    boxShadow: "0 0 0 0 #d9d9d9",
    borderTopLeftRadius: state.menuIsOpen ? "20px" : "40px",
    borderTopRightRadius: state.menuIsOpen ? "20px" : "40px",
    borderBottomLeftRadius: state.menuIsOpen ? "0" : "40px",
    borderBottomRightRadius: state.menuIsOpen ? "0" : "40px",
    "&:hover": {
      borderColor: "#d9d9d9",
      boxShadow: "0 0 0 1px #d9d9d9",
    },
  }),
};

const countryListItemDisplay = (item) => (
  <div className="country">
    <img
      data-test="country-selected-flag"
      className="flag"
      height="19px"
      alt="Country flag"
      src={`/svg/flags/4x3/${item.country_code.toLowerCase()}.svg`}
      style={{
        marginRight: "10px",
      }}
    />
    <div data-test="country-selected-name" className="country-name">{item.country}</div>
  </div>
);

const CountrySelector = ({
  selected = "AU", style, onChange, placeholder, countries, nameAsValue,
}) => {
  const labeledCountryArray = useCallback(() => countries.map((country) => ({
    value: nameAsValue ? country.country : country.country_code,
    label: countryListItemDisplay(country),
  }), this), [countries, nameAsValue]);
  return (
    <div data-test="country-selector" className={!style ? "country-selector" : `country-selector country-selector__${style}`}>
      <Select
        styles={customStyles}
        clearable={false}
        deleteRemoves={false}
        name="countrySelector"
        onChange={onChange}
        options={labeledCountryArray()}
        removeSelected={false}
        searchable={false}
        placeholder={placeholder}
        defaultValue={OptionsAdapter().defaultOption(selected, countryListItemDisplay({
          country_code: selected,
          country: "Australia",
        }))}
      />
    </div>
  );
};

CountrySelector.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  displayImage: PropTypes.bool,
  style: PropTypes.string,
};

export default CountrySelector;
